//import Popper from 'node_modules/popper.js';

//import {BootstrapVue} from 'node_modules/bootstrap-vue';
/* import the fontawesome core */
import {library} from 'node_modules/@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import {FontAwesomeIcon} from 'node_modules/@fortawesome/vue-fontawesome';

/* import specific icons */
import {
	faPencil as fasPencil,
	faFilter as fasFilter,
	faStar as fasStar,
	faCaretDown as fasCaretDown,
	faCaretLeft as fasCaretLeft,
	faPlus as fasPlus,
	faMinus as fasMinus,
	faSpinner as fasSpinner,
	faCheck as fasCheck,
	faXmark as fasXmark,
	faTriangleExclamation as fasTriangleExclamation
} from 'node_modules/@fortawesome/free-solid-svg-icons';
import {faStar as farStar, faSquareCheck as farSquareCheck} from 'node_modules/@fortawesome/free-regular-svg-icons';

import EventShifts from "./event_shifts.vue";

/* add icons to the library */
library.add(fasStar, farStar, fasCaretDown, fasCaretLeft, fasPlus, fasMinus, fasSpinner, farSquareCheck, fasCheck, fasXmark, fasTriangleExclamation, fasPencil, fasFilter);

// // Make BootstrapVue available throughout your project
// Vue.use(BootstrapVue)
// // Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

frappe.provide('frappe.EventShifts');
frappe.EventShifts = EventShifts;
